export const LabelTestIdFactory = {
    getLabelBase: () => 'label',
    getLabelListBase: () => [LabelTestIdFactory.getLabelBase(), 'list'].join('-'),
    getLabelListRemainingBase: () => [LabelTestIdFactory.getLabelListBase(), 'remaining'].join('-'),
    getLabelTextBase: () => [LabelTestIdFactory.getLabelBase(), 'text'].join('-'),
    getLabelTestId: (testId) => [LabelTestIdFactory.getLabelBase(), testId].join('-'),
    getLabelListTestId: (testId) => [LabelTestIdFactory.getLabelListBase(), testId].join('-'),
    getLabelListRemainingTestId: (testId) => [LabelTestIdFactory.getLabelListRemainingBase(), testId].join('-'),
    getLabelTextTestId: (testId) => [LabelTestIdFactory.getLabelTextBase(), testId].join('-'),
};
